import accounting from "accounting"

import { formatCurrency } from "../../../components/KpiCards/kpiCards"

const { formatNumber } = accounting

export const buildKpiCards = (kpi) => [
  {
    key: "disputes_stopped",
    label: "Disputes stopped",
    subtitle: "_rate_% of decided fraud disputes",
    subtitleValues: { rate: Math.round(kpi?.stoppedRate ?? 0) },
    value: formatNumber(kpi?.disputesStopped ?? 0, 0, ",")
  },
  {
    key: "revenue_protected",
    label: "Revenue protected",
    subtitle: "Didn't become chargebacks",
    value: formatCurrency(kpi?.revenueProtected)
  },
  {
    key: "fees_charged",
    label: "Fees charged",
    subtitle: "Fees charged to your balance",
    value: formatCurrency(kpi?.feesCharged)
  }
]
